import React from 'react';
import { GetServerSideProps } from 'next';
import { getLocaleProps, LocaleProps, WithLocale } from '@components/I18n';
import { AuthenticationProps, getAuthenticationProps, WithAuthentication } from '@components/Authentication';
import { LoginOrErrorOrPage, PageWrapper, InvoicesPage } from '@components/.';
import { SubscriptionController, StripeInvoiceInfos, withCookie } from '@oward/openapi';

interface PageProps {
  invoices?: StripeInvoiceInfos[],
  errorMsg?: string;
  notLogged?: boolean;
}

export const getServerSideProps: GetServerSideProps = async context => {
  let pageProps: PageProps;
  const locale = context.params.lang as string;
  const localeProps = await getLocaleProps(locale);
  const authenticationProps = await getAuthenticationProps(context);

  if (authenticationProps.currentUser === null) {
    pageProps = { notLogged: true }
  }
  else {
    let cookie = context.req.headers.cookie;
    try {
      let invoices: StripeInvoiceInfos[] = await withCookie(cookie)(SubscriptionController.getStripeInvoices());
      pageProps = {
        invoices: invoices
      }
    }
    catch (error) {
      pageProps = { errorMsg: (error as Error)?.message }
    }
  }

  return {
    props: {
      ...pageProps,
      ...authenticationProps,
      ...localeProps
    }
  }
}

const Page: React.FC<PageProps & LocaleProps & AuthenticationProps> = props => {
  return (
    <PageWrapper>
      <LoginOrErrorOrPage
        errorMsg={props.errorMsg}
        notLogged={props.notLogged}
      >
        <InvoicesPage invoices={props.invoices} />
      </LoginOrErrorOrPage>
    </PageWrapper>
  );
}

const CompletePage: React.FC<PageProps & LocaleProps & AuthenticationProps> = props => {
  return (
    <WithLocale {...props}>
      <WithAuthentication {...props}>
        <Page {...props} />
      </WithAuthentication>
    </WithLocale>
  );
}

export default CompletePage;

